import React from "react";
import { Link } from "react-router-dom";
import { FiActivity, FiArrowRight, FiArrowUpRight, FiCode, FiShield, FiZap } from "react-icons/fi";
import BrandPageShell from "../BrandPageShell";
import key from "../../assets/key.png";
import liquidity from "../../assets/exchange_liquidity.png";
import speed from "../../assets/speed.png";
import trade from "../../assets/trade.png";
import ease from "../../assets/ease.png";
import laptop from "../../assets/web-signup.svg";
import wallet from "../../assets/wallet.png";
import secure from "../../assets/safe.png";
import "./Exchange.css";

const name = "Profitmonitoring";

const benefits = [
  {
    label: "FEES",
    image: key,
    icon: <FiActivity aria-hidden="true" />,
    text: "Get rewarded the more you trade. " + name + " offers a dynamic, tiered fee structure that’s highly competitive and carefully designed to ensure that you’ll pay lower fees based on your gross trading volume.",
  },
  {
    label: "API",
    image: wallet,
    icon: <FiCode aria-hidden="true" />,
    text: "The " + name + " API gives you an easy way to integrate into the Exchange platform, allowing you to programmatically manage your account, make trades and retrieve market data.",
  },
  {
    label: "SECURITY",
    image: secure,
    icon: <FiShield aria-hidden="true" />,
    text: name + "'s industry-leading security measures work to keep your crypto safe. " + name + " stores 95% of crypto in “deep freeze” – multi-signature wallets protected by many layers of encryption.",
  },
];

const features = [
  {
    title: "Liquidity",
    image: liquidity,
    text: "Our liquidity ensures the tightest spreads so that your crypto trades are executed as close to the price you want as possible, maximising your profits. Liquidity is driven by our low fees, high volume and many active traders.",
  },
  {
    title: "Speed",
    image: ease,
    text: "Execute trades in microseconds without compromising reliability or security. Our low-latency trading platform has all the tools you need to make the most of market opportunities, whenever and wherever you are.",
  },
  {
    title: "Ease",
    image: speed,
    text: "Enjoy an intuitive user experience designed for smooth, efficient trading. Luno is optimised for ease-of-use, offering simple order placement and high-quality charting tools to give you the best chance of success – whatever your experience level.",
  },
  {
    title: "Trade on the go",
    image: trade,
    text: "Deposit, withdraw, and trade 24/7 on our mobile apps for Android and iOS, so you can experience professional-level crypto exchange features on the move.",
  },
];

export default function Exchange() {
  return (
    <BrandPageShell active="/exchange" pageClassName="exchange-page">
      <section className="exchange-hero">
        <div className="exchange-container exchange-hero-grid">
          <div className="exchange-hero-copy">
            <span className="exchange-kicker">MARKETS / EXCHANGE</span>
            <h1>High-performance crypto exchange</h1>
            <p>Easy-to-use interface, industry-leading security, deep liquidity</p>
            <Link className="exchange-button exchange-button-light" to="/wallet">View Exchange <FiArrowRight size={15} /></Link>
            <span className="exchange-hero-note">PROFITGROWING / MARKET ACCESS</span>
          </div>
          <div className="exchange-hero-visual">
            <span className="exchange-visual-index">01 / EXCHANGE</span>
            <img src={laptop} alt="" aria-hidden="true" />
            <div className="exchange-visual-caption"><span><FiActivity size={16} /></span><strong>Explore the market</strong><FiArrowUpRight size={16} /></div>
          </div>
        </div>
      </section>

      <section className="exchange-overview">
        <div className="exchange-container">
          <div className="exchange-section-heading">
            <span className="exchange-section-kicker">MADE FOR MARKET PARTICIPATION</span>
            <h2>Trading with {name}</h2>
            <p>Dynamic cryptocurrency trading that puts you in the driver's seat</p>
          </div>
          <div className="exchange-benefit-grid">
            {benefits.map((benefit, index) => (
              <article className="exchange-benefit-card" key={benefit.label}>
                <div className="exchange-benefit-top"><span>{String(index + 1).padStart(2, "0")} / {benefit.label}</span>{benefit.icon}</div>
                <img src={benefit.image} alt="" aria-hidden="true" />
                <p>{benefit.text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="exchange-features">
        <div className="exchange-container">
          <div className="exchange-section-heading exchange-section-heading--left">
            <span className="exchange-section-kicker">THE PLATFORM</span>
            <h2>Tools for your trading journey.</h2>
            <p>Explore the exchange experience and its key features.</p>
          </div>
          <div className="exchange-feature-grid">
            {features.map((feature, index) => (
              <article className="exchange-feature-card" key={feature.title}>
                <div className="exchange-feature-image"><img src={feature.image} alt="" aria-hidden="true" /><span>{String(index + 1).padStart(2, "0")}</span></div>
                <div className="exchange-feature-copy"><h3>{feature.title}</h3><p>{feature.text}</p></div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="exchange-cta">
        <div className="exchange-container exchange-cta-row">
          <div><span className="exchange-section-kicker">YOUR NEXT STEP</span><h2>The cryptocurrency market is waiting</h2><p>Your trading journey starts now</p></div>
          <Link className="exchange-button exchange-button-outline" to="/wallet">View Exchange <FiArrowUpRight size={15} /></Link>
        </div>
      </section>
    </BrandPageShell>
  );
}
